import { apiClient } from '@/to-fsd/shared/api';

export const creditsService = {
  getApp() {
    return apiClient.get('/merchant/credit/credits/app');
  },
};

export default creditsService;
